export const TermsAndConditionsData = [
    {
      title: 'Eligibility',
      content: 'You must be at least [minimum age] years old to use the App. By using the App, you represent and warrant that you meet the age requirements.',
    },
    {
      title: 'License',
      content: 'The Company grants you a limited, non-exclusive, non-transferable, and revocable license to use the App for its intended purpose, subject to the terms and conditions of this Agreement.',
    },
    {
      title: 'User Account',
      content: 'You may be required to create a user account to access certain features of the App. You are responsible for maintaining the confidentiality of your account credentials and for any activities or actions taken under your account.',
    },
    {
      title: 'Prohibited Conduct',
      content: 'You agree not to engage in any conduct that violates applicable laws, infringes upon the rights of others, or disrupts the functioning of the App. Prohibited conduct includes, but is not limited to, the following: - Unauthorized access to the App or its related systems. - Attempting to interfere with or manipulate the App\'s security features or its functionality. - Uploading or transmitting viruses, malware, or any other harmful code. - Engaging in any fraudulent or deceptive activities.',
    },
  ];
  